// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1vnDj","noPadding":"Button_noPadding__3712H","primary":"Button_primary__Celrb"};